<template>
    <div
        id="contact-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <div class="contact-form">
            <base-text type="h3">Contact Us</base-text>
            <form
                name="contact"
                method="post"
                data-netlify="true"
                netlify-honeypot="bot-field"
            >
                <input type="hidden" name="form-name" value="contact" />
                <template v-for="(input, index) in data.inputs">
                    <input
                        v-if="input.type !== 'textarea'"
                        :key="`${index}-input`"
                        :name="input.name"
                        :id="input.name"
                        :type="input.type"
                    />
                    <textarea
                        v-else
                        :key="`${index}-input`"
                        :name="input.name"
                        :id="input.name"
                    />
                    <label :key="`${index}-label`" :for="input.name">
                        <base-text type="p">{{ input.label }}</base-text>
                    </label>
                </template>

                <base-button
                    type="button"
                    button-type="submit"
                    design="secondary"
                >
                    Submit
                </base-button>
            </form>
        </div>
        <base-window class="map">
            <div v-html="data.map" />
        </base-window>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/contact.md';

    export default {
        name: 'contact',

        mixins: [dataLoader(data)],
    };
</script>

<style lang="scss" scoped>
    #contact-page {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        min-height: calc(100vh - #{$footer-height});

        .contact-form {
            width: 40%;

            h3 {
                margin-bottom: $standard-space;
            }

            form {
                display: flex;
                flex-direction: column;
                width: 100%;

                label {
                    color: #fff;
                    margin-top: 8px;

                    &:not(:last-of-type) {
                        margin-bottom: 30px;
                    }
                }

                input,
                textarea {
                    background: rgba(#f9f9f9, 0.8);
                    padding: 10px;
                    border: 0;

                    &:focus {
                        outline: 3px solid rgba($purple, 0.3);
                    }
                }

                textarea {
                    height: 150px;
                    resize: none;
                }

                button[type='submit'] {
                    align-self: flex-end;
                    margin-top: 30px;
                }
            }
        }

        .map {
            width: 50%;
            /deep/ iframe {
                width: 100%;
            }
        }

        &.tablet,
        &.mobile {
            flex-direction: column;
            margin-top: 100px;

            .contact-form,
            .map {
                width: 100%;
                margin-bottom: $standard-space;
            }
        }
    }
</style>
